export default __webpack_public_path__ + "static/media/wallet.d4338645.svg";